module.exports = __webpack_public_path__ + "img/64.9af453a2.jpg";